'use client'

import { Card } from 'my-purchases/components/Card/Card'
import { Status } from 'my-purchases/components/Card/components/Status/Status'
import type { CardStatus } from 'my-purchases/types/purchaseList'
import { Fragment } from 'react'

import { Action } from './components/Action/Action'
import {
	ArticleInfo,
	type ColorBullet,
} from './components/ArticleInfo/ArticleInfo'
import {
	ArticlePrice,
	type ArticlePrices,
} from './components/ArticlePrice/ArticlePrice'

import styles from './ArticleCard.module.scss'

interface ArticleCardProps {
	readonly 'data-testid': string
	readonly name: string
	readonly uniqueId?: string
	readonly reference: string
	readonly imgSrc?: string
	readonly size: string
	readonly status?: CardStatus
	readonly isDisabled?: boolean
	readonly color: ColorBullet
	readonly prices: ArticlePrices
	readonly checkboxConfig?: {
		isSelected?: boolean
		onSelect: (uniqueId: string) => void
	}
	readonly actionConfig?: {
		actionLabel: string
		onActionClick: (uniqueId: string) => void
	}
	readonly linkConfig?: {
		href: string
		target?: string
	}
	readonly showSeparator?: boolean
}
export function ArticleCard({
	'data-testid': dataTestId,
	name,
	reference,
	uniqueId = reference,
	imgSrc,
	size,
	status,
	isDisabled,
	actionConfig,
	color,
	prices,
	linkConfig,
	checkboxConfig,
	showSeparator,
}: ArticleCardProps) {
	const Wrapper = linkConfig ? 'a' : Fragment

	return (
		<Wrapper
			{...(linkConfig && {
				...linkConfig,
				className: styles.link,
			})}
		>
			<Card
				data-testid={dataTestId}
				isDisabled={isDisabled}
				imageSrc={imgSrc ?? ''}
				showSeparator={showSeparator}
				checkboxConfig={checkboxConfig}
				uniqueId={uniqueId}
			>
				<div className={styles.container}>
					<div className={styles.header}>
						<ArticleInfo
							data-testid={dataTestId}
							name={name}
							reference={reference}
							size={size}
							color={color}
						/>
						<ArticlePrice data-testid={dataTestId} prices={prices} />
					</div>

					<div className={styles.footer}>
						{status && <Status data-testid={dataTestId} status={status} />}
						{!!actionConfig && !isDisabled && (
							<Action
								data-testid={`${dataTestId}.action`}
								onClick={() => actionConfig.onActionClick(uniqueId)}
								label={actionConfig.actionLabel ?? ''}
							/>
						)}
					</div>
				</div>
			</Card>
		</Wrapper>
	)
}
